import {resourceTypes} from '@/components/timeline/resource-types';

export const makeResourceRouteMap = {
    [resourceTypes.invoice]: ({resourceId}) => ({name: 'invoice-details', params: {id: resourceId}}),
    [resourceTypes.transaction]: ({resourceId}) => ({name: 'transaction-details', params: {id: resourceId}}),
    [resourceTypes.subscription]: ({resourceId}) => ({name: 'order-details', params: {id: resourceId}}),
    [resourceTypes.creditMemo]: ({resourceId}) => ({name: 'credit-memo-details', params: {id: resourceId}}),
    [resourceTypes.coupon]: ({resourceId}) => ({name: 'coupon-details', params: {id: resourceId}}),
};

export const routableResourceTypes = Object.keys(makeResourceRouteMap);

export default ({
    resourceType,
    resourceId,
}) => makeResourceRouteMap[resourceType]({resourceId});
